import {
  createEvent as createEventThunk,
  fetchEventsList as fetchEventsListThunk,
  updateEvent as updateEventThunk,
  deleteEvent as deleteEventThunk,
  clearEventState,
} from "../reducers/eventsSlice";

// Create Event
export const createEvent = (adminData, payload) => {
  return (dispatch) => {
    return dispatch(createEventThunk({ adminData, payload }));
  };
};

// Fetch Events List
export const fetchEventsList = (adminData) => {
  return (dispatch) => {
    return dispatch(fetchEventsListThunk(adminData));
  };
};

// Update Event
export const updateEvent = (adminData, payload) => {
  return (dispatch) => {
    return dispatch(updateEventThunk({ adminData, payload }));
  };
};

// Delete Event
export const deleteEvent = (adminData, payload) => {
  return (dispatch) => {
    return dispatch(
      deleteEventThunk({ adminData, eventId: payload.eventId })
    );
  };
};

// Clear Event State
export { clearEventState };
